var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"name":("'" + _vm.label + "'"),"rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('mail-list',{attrs:{"value":_vm.innerValue,"required":_vm.required,"error-messages":errors,"readonly":_vm.readonly,"label":_vm.label,"required-color":_vm.requiredColor},on:{"input":_vm.change}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }